"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ProjectFormat_1 = require("../../enums/ProjectFormat/ProjectFormat");
const ProjectTheme_1 = require("../../enums/ProjectTheme/ProjectTheme");
const Resource_1 = __importDefault(require("../Resource"));
const ProjectPurpose_1 = require("../../enums/ProjectPurpose");
class ProjectUpdateRequestResource extends Resource_1.default {
}
exports.default = ProjectUpdateRequestResource;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(100, { context: [100] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectUpdateRequestResource.prototype, "title", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(150, { context: [150] }),
    (0, class_validator_1.MaxLength)(2000, { context: [2000] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectUpdateRequestResource.prototype, "pitch", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ProjectFormat_1.EProjectFormat),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectUpdateRequestResource.prototype, "format", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(ProjectTheme_1.EProjectTheme),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectUpdateRequestResource.prototype, "theme", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => {
        if (!Array.isArray(value)) {
            return [value];
        }
        return value;
    }),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsEnum)(ProjectPurpose_1.EProjectPurpose, { each: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], ProjectUpdateRequestResource.prototype, "purposes", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUrl)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectUpdateRequestResource.prototype, "discord", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUrl)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectUpdateRequestResource.prototype, "instagram", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUrl)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectUpdateRequestResource.prototype, "x", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUrl)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectUpdateRequestResource.prototype, "linkedin", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProjectUpdateRequestResource.prototype, "lang", void 0);
